import isObject from './isObject.js';

function isPromiseLike(value) {
    return isObject(value) && typeof value.then === 'function';
}

export { isPromiseLike as default };
